// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__3aIp6","hover":"Backdrop_hover__1gNrL"};